module.exports = __webpack_public_path__ + "static/img/hero-image@3x.adb694f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero-image@3x.png
// module id = gyzR
// module chunks = 6